import type { Maybe } from "gql/api";

export function getEnumKeyByValue(
  myEnum: any,
  enumValue: Maybe<string> | undefined | undefined
): string {
  if (!enumValue) return "";
  const keys = Object.keys(myEnum).filter(x => myEnum[x] === enumValue);
  return keys.length > 0 ? keys[0].split(/(?=[A-Z])/).join(" ") : "";
}

export enum DiscardAction {
  DISCARD,
  SAVE,
  CANCEL
}
